import { fetchWithAuth } from '@shared/utils/auth';

export async function fetchForecasterByUrl(url) {
  if (!url) throw new Error("URL для следующей страницы не задан");

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при получении данных Forecasters');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API fetchForecasterTweetsByUrl error:', error);
    throw error;
  }
}